// extracted by mini-css-extract-plugin
export var card = "OfferCard-module--card--30290";
export var copy = "OfferCard-module--copy--260e9";
export var cta = "OfferCard-module--cta--e0888";
export var expiry = "OfferCard-module--expiry--a87db";
export var image = "OfferCard-module--image--f1c4a";
export var imageWrapper = "OfferCard-module--imageWrapper--d464d";
export var mobileOnlyCta = "OfferCard-module--mobileOnlyCta--9f1dd";
export var spacer = "OfferCard-module--spacer--09322";
export var terms = "OfferCard-module--terms--33e0b";
export var title = "OfferCard-module--title--7cb48";
export var wideCopy = "OfferCard-module--wideCopy--f6e82";
export var wideCta = "OfferCard-module--wideCta--37f0d";